import { ReactKeycloakProvider } from "@react-keycloak/web";
import { LoaderComponent } from "agrichema-component-library";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./i18n";
import App from "./pages/App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "./styles/index.scss";
import keycloak from "./utils/KeyCloak";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryFallbackComponent from "./components/errorBoundaryComponent/ErrorBoundaryFallbackComponents";

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<LoaderComponent fullscreen />}>
      <ReactKeycloakProvider
        authClient={keycloak}
        LoadingComponent={<LoaderComponent fullscreen />}
      >
        <ErrorBoundary FallbackComponent={ErrorBoundaryFallbackComponent}>
          <App />
        </ErrorBoundary>
      </ReactKeycloakProvider>
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.debug);
